export default __webpack_public_path__ + "static/media/Amealio_Illustrations-08.5021232d.png";